export const ACCESS = 'accesses'
export const ADV = 'advs'
export const ANNEX_TYPE = 'annex-types'
export const CALENDAR = 'rdvs'
export const CALENDAR_EVENT = 'calendar-events'
export const COMPANY = 'companies'
export const CONTACT = 'contacts'
export const DEBUG_USER_STATS = 'stats/debug/user'
export const DEBUG_OPTION_STATS = 'stats/debug/option'
export const DENUNCIATION = 'denunciations'
export const EVENT = 'events'
export const EXTERNAL_ACCESS = 'external-accesses'
export const FLUX = 'flux-events'
export const LOGIN = 'login'
export const LOT = 'lots'
export const ALLOTMENTS = 'allotments'
export const ME = 'me'
export const OPTION = 'options'
export const ORIGIN = 'origins'
export const POLES = 'poles'
export const PROFIL = 'profils'
export const PROGRAM = 'programs'
export const PROMOTEUR = 'promoteurs'
export const PROMOTEUR_ACCESSES = 'promoteur-accesses'
export const PROPOSAL = 'proposals'
export const REGISTER = 'register'
export const REMINDER = 'reminders'
export const RESEARCHES = 'contact-researches'
export const SEARCH = 'search'
export const SELLER = 'sellers'
export const STATES = 'states'
export const STATISTICS = 'stats'
export const UPLOAD = 'file-upload'
export const USER = 'users'
export const WISHLIST = 'wishlists'
export const LEAD = 'leads'
export const ASYNC_FILE_ZIP = 'async-file-zip'



// WEBPACK FOOTER //
// ./src/services/api/apiUrls.js